module.exports = __webpack_public_path__ + "static/media/megaphone.992c15cc.svg";